export default __webpack_public_path__ + "static/media/add-bandwidth.bf492df4.svg";